import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ROUTES, { DOCTOR_ROUTES } from "../../../routes/patientRoutes/routePaths";
import medilinkLogo from "../../../assets/images/medilink.svg";
import "./AuthPageFrame.css";

export default function AuthPageFrame({ role, children }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isPatient = role === "patient";
  const otherRolePath = isPatient ? DOCTOR_ROUTES.LOGIN : ROUTES.LOGIN;
  const otherRoleLabel = isPatient
    ? t("signup.continueAsDoctor", "Continue as a doctor")
    : t("signup.continueAsPatient", "Continue as a patient");

  return (
    <div className={`auth-page-frame auth-page-frame--${role}`}>
      <header className="auth-page-frame__header">
        <button
          type="button"
          className="auth-page-frame__brand"
          onClick={() => navigate(ROUTES.LANDING)}
          aria-label={t("common.backToHome", "Back to home page")}
        >
          <img src={medilinkLogo} alt="Medilink" />
        </button>
      </header>

      <main className="auth-page-frame__main">{children}</main>

      <footer className="auth-page-frame__footer">
        <button
          className="auth-page-frame__role-link"
          type="button"
          onClick={() => navigate(otherRolePath)}
        >
          {otherRoleLabel}
        </button>
      </footer>
    </div>
  );
}
